import state from './state'
import * as mutations from './mutations'
import * as getters from './getters'

const store = {
	state,
	mutations,
	getters
}
export default store
